import './Footer.scss';

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-meta">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <p className="btn-row text-center">
                                <a href="https://www.facebook.com/moto4rent.ro" target="_blank" className="btn btn-theme ripple-effect btn-icon-left facebook wow fadeInDown" data-wow-offset="20" data-wow-delay="100ms"><i className="fa fa-facebook"></i>FACEBOOK</a>
                                <a href="https://www.instagram.com/moto4rent.ro/" target="_blank" className="btn btn-theme btn-icon-left ripple-effect twitter wow fadeInDown" data-wow-offset="20" data-wow-delay="200ms"><i className="fa fa-instagram"></i>INSTAGRAM</a>
                                <a href="https://www.youtube.com/@moto4rent-ro123" target="_blank" className="btn btn-theme btn-icon-left ripple-effect pinterest wow fadeInDown" data-wow-offset="20" data-wow-delay="300ms"><i className="fa fa-youtube"></i>YOUTUBE</a>
                                <a href="https://www.tiktok.com/@moto4rent" target="_blank" className="btn btn-theme btn-icon-left ripple-effect google wow fadeInDown" data-wow-offset="20" data-wow-delay="400ms"><i className="fa fa-tumblr"></i>TikTok</a>
                                <a href="https://play.google.com/store/apps/details?id=com.moto4rent.renting_app&hl=ro&gl=US" target="_blank" className="btn btn-theme btn-icon-left ripple-effect  wow fadeInDown" data-wow-offset="20" data-wow-delay="400ms"><i className="fa fa-play"></i>GOOGLE PLAY</a>
                            </p>
                            <div className="copyright">&copy; 2023 Moto4Rent</div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}